import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Circle, Clock, ChevronRight } from 'lucide-react';
import { useAiCommandPalette } from '../context/AiCommandPaletteContext';
import AiOption from './AiOption';

const SearchResults = () => {
  const {
    searchResults,
    selectedIndex,
    setSelectedIndex,
    inputValue,
    isLoading,
    handleNavigateToTask,
    isAskMode,
    conversationHistory
  } = useAiCommandPalette();
  
  // Don't show search results when in ask mode with a conversation
  if (isAskMode && conversationHistory.length > 0) return null;

  const getStatusIcon = (status) => {
    switch (status) {
      case 'done':
        return <CheckCircle2 className="h-4 w-4 text-indigo-500" />;
      case 'in_progress':
        return <Clock className="h-4 w-4 text-blue-500" />;
      default:
        return <Circle className="h-4 w-4 text-gray-400" />;
    }
  };

  if (!inputValue.trim()) return null;

  return (
    <div 
      className={`${inputValue.trim() ? 'p-4' : ''}`}
      onMouseLeave={() => setSelectedIndex(-1)}
      onMouseMove={(e) => {
        // Only reset selection if mouse is directly on the container but not on a result item
        if (e.target === e.currentTarget) {
          setSelectedIndex(-1);
        }
      }}
    >      
      {searchResults.map((result, index) => (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          key={result.id}
          onClick={() => handleNavigateToTask(result)}
          onMouseMove={() => setSelectedIndex(index)}
          className={`p-3 rounded-lg cursor-pointer group transition-colors ${
            index === selectedIndex
              ? 'bg-violet-50 dark:bg-violet-500/10'
              : ''
          }`}
        >
          <div className="flex items-start gap-3">
            <div className="pt-1">
              {getStatusIcon(result.status)}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium text-foreground transition-colors">
                {result.summary}
              </div>
              <div className="text-sm text-muted-foreground flex items-center gap-2 mt-1">
                {result.key && <span>{result.key}</span>}
                {result.project?.name && (
                  <>
                    <span className="h-1 w-1 bg-violet-200 dark:bg-violet-500/20 rounded-full" />
                    <span>{result.project.name}</span>
                  </>
                )}
                {result.assignee && (
                  <>
                    <span className="h-1 w-1 bg-violet-200 dark:bg-violet-500/20 rounded-full" />
                    <span className="flex items-center gap-1">
                      <span className={`w-2 h-2 rounded-full ${result.assignee.avatarColor}`} />
                      {result.assignee.name}
                    </span>
                  </>
                )}
              </div>
            </div>
            <div className="flex items-center self-center">
              <ChevronRight className={`h-4 w-4 text-muted-foreground transition-opacity ${
                index === selectedIndex ? 'opacity-100' : 'opacity-0'
              }`} />
            </div>
          </div>
        </motion.div>
      ))}

      <AiOption />
      
      {/* {inputValue.trim() && searchResults.length === 0 && !isLoading && (
        <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
          <p className="text-muted-foreground">
            No matching results found.
          </p>
        </div>
      )} */}
    </div>
  );
};

export default SearchResults; 